const SettlementSearchKeysEnum = Object.assign({
  SETTLEMENT_ID: { text: 'Settlement ID', value: 'id' },
  USER_ID: { text: 'User ID', value: 'userId' },
  STATUS: { text: 'Status', value: 'status' },
  SECURITY_ID: { text: 'Token Symbol', value: 'securityId' },
  TRANCHE_ID: { text: 'Tranche ID', value: 'trancheId' },
});

Object.freeze(SettlementSearchKeysEnum);

export default SettlementSearchKeysEnum;



// WEBPACK FOOTER //
// ./src/enum/settlements/SettlementSearchKeys.js